// Export gate experiment (2026-06): free users cannot download exports;
// publishing/scheduling stays free. Must match EXPORT_REQUIRES_PAID_PLAN
// in server/src/index.ts. Flip both to false to revert the experiment.
export const EXPORT_GATE_ENABLED = true;
